'use client';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { Plus, Minus } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/tscapi/utils/utils';
function Accordion({ ...props }: React.ComponentProps<typeof AccordionPrimitive.Root>) {
    return <AccordionPrimitive.Root data-slot="accordion" {...props} />;
}
function AccordionItem({ className, ...props }: React.ComponentProps<typeof AccordionPrimitive.Item>) {
    return (
        <AccordionPrimitive.Item
            data-slot="accordion-item"
            className={cn('my-5 border-b bg-[#f8f8f8] px-5 py-3 last:border-b-0', className)}
            {...props}
        />
    );
}
function AccordionTrigger({ className, children, ...props }: React.ComponentProps<typeof AccordionPrimitive.Trigger>) {
    return (
        <AccordionPrimitive.Header className="m-0 flex p-0 text-base">
            <AccordionPrimitive.Trigger
                data-slot="accordion-trigger"
                className={cn(
                    'group flex flex-1 items-center justify-between gap-4 py-4 text-left text-sm font-semibold outline-none transition-all hover:no-underline focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50',
                    className,
                )}
                {...props}
            >
                {children}
                {/* Show Plus when closed, Minus when open */}
                <Plus
                    color="#000000"
                    className="pointer-events-none shrink-0 translate-y-0.5 text-muted-foreground group-data-[state=open]:hidden"
                />
                <Minus
                    color="#000000"
                    className="pointer-events-none hidden shrink-0 translate-y-0.5 text-muted-foreground group-data-[state=open]:!block"
                />
            </AccordionPrimitive.Trigger>
        </AccordionPrimitive.Header>
    );
}
function AccordionContent({ className, children, ...props }: React.ComponentProps<typeof AccordionPrimitive.Content>) {
    return (
        <AccordionPrimitive.Content
            data-slot="accordion-content"
            className="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
            {...props}
        >
            <div className={cn('pb-4 pt-0', className)}>{children}</div>
        </AccordionPrimitive.Content>
    );
}
export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
